export enum MarketTypeGroup {
  WINNER = "Winner",
  TOTALS = "Totals",
  HANDICAP = "Handicap",
  DOUBLE_CHANCE = "Double chance",
  DRAW_NO_BET = "Draw no bet",
  BOTH_TEAMS_TO_SCORE = "Both teams to score",
  FIRST_HALF = "1st half",
  SECOND_HALF = "2nd half",
  FIRST_SET = "1st set",
  SECOND_SET = "2nd set",
  THIRD_SET = "3rd set",
  SETS = "Sets",
  GAMES = "Games",
  SGP = "SGP",
  // QUICK_SGP = "Quick SGP",
  PLAYER_PROPS = "All player props",
  GAME_PROPS = "Game props",
  PLAYER_POINTS = "Player points",
  PLAYER_REBOUNDS = "Player rebounds",
  PLAYER_ASSISTS = "Player assists",
  PLAYER_TURNOVERS = "Player turnovers",
  PLAYER_THRESS = "Player threes",
  PLAYER_TWO_POINTERS = "Player two pointers",
  PLAYER_FREE_THROWS = "Player free throws",
  PLAYER_FIELD_GOALS = "Player field goals",
  PLAYER_BLOCKS = "Player blocks",
  PLAYER_STEALS = "Player steals",
  PLAYER_DOUBLE_DOUBLE = "Player double double",
  PLAYER_TRIPLE_DOUBLE = "Player triple double",
  PLAYER_COMBOS = "Player combos",
  PLAYER_DEFENSE = "Player defense",
  PLAYER_GOALS = "Goalscorer",
  PLAYER_SHOTS = "Shots on goal",
  PLAYER_BATTER = "Batter",
  PLAYER_PITCHER = "Pitcher",
  PLAYER_TOUCHDOWN_SCORERS = "TD scorers",
  PLAYER_PASSING = "Passing props",
  PLAYER_RUSHING = "Rushing props",
  PLAYER_RECEIVING = "Receiving props",
  PLAYER_DEFENSE_SPECIAL_TEAMS = "D/ST props",
  PLAYER_KICKING = "Kicking props",
  POINTS = "Points",
  QUARTERS = "Quarters",
  FIRST_QUARTER = "1st quarter",
  SECOND_QUARTER = "2nd quarter",
  THIRD_QUARTER = "3rd quarter",
  FOURTH_QUARTER = "4th quarter",
  HALVES = "Halves",
  WINNING_METHOD = "Winning method",
  FIGHT_PROPS = "Fight props",
  ROUND_PROPS = "Round props",
  INNINGS = "Innings",
  FIRST_INNING = "1st inning",
  FIRST_THREE_INNINGS = "1st 3 innings",
  FIRST_FIVE_INNINGS = "1st 5 innings",
  FIRST_SEVEN_INNINGS = "1st 7 innings",
  POPULAR_VOTE_WINNER = "Popular vote winner",
  WINNING_PARTY = "Winning party",
  WINNING_PARTY_STATE = "Winning party (states)",
  CORNERS = "Corners",
  CARDS = "Cards",
  KILLS_PROPS = "Kill props",
  ASSISTS_PROPS = "Assist props",
  DEATHS_PROPS = "Death props",
  HEADSHOTS_PROPS = "Headshot props",
}
